import { GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, sprintf } from '~/locale';
export default {
    name: 'DesignNotePin',
    components: {
        GlIcon
    },
    props: {
        position: {
            type: Object,
            required: false,
            default: null
        },
        label: {
            type: Number,
            required: false,
            default: null
        },
        isResolved: {
            type: Boolean,
            required: false,
            default: false
        },
        isInactive: {
            type: Boolean,
            required: false,
            default: false
        },
        isOnImage: {
            type: Boolean,
            required: false,
            default: false
        },
        isDraft: {
            type: Boolean,
            required: false,
            default: false
        },
        size: {
            type: String,
            required: false,
            default: 'md',
            validator: (value)=>[
                    'sm',
                    'md'
                ].includes(value)
        },
        ariaLabel: {
            type: String,
            required: false,
            default: null
        },
        clickable: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    emits: [
        'click',
        'mousedown',
        'mouseup'
    ],
    computed: {
        isNewNote () {
            return this.label === null;
        },
        pinLabel () {
            if (this.ariaLabel) {
                return this.ariaLabel;
            }
            return this.isNewNote ? __('Comment form position') : sprintf(__("Comment '%{label}' position"), {
                label: this.label
            });
        }
    }
};
